(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var getSession = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
		var configData, selectedModel;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						configData = sessionStorage.getItem("configData");
						_context.next = 3;
						return JSON.parse(configData).modelName;

					case 3:
						selectedModel = _context.sent;
						return _context.abrupt('return', selectedModel);

					case 5:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function getSession() {
		return _ref.apply(this, arguments);
	};
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

jQuery(document).ready(function () {
	//get current parameters and break into individual variables to track possible options changes
	var currentParams = location.href.split('?')[1];
	var urlVariables = currentParams.split('&');
	var storedOptions;
	var configData = JSON.parse(sessionStorage.getItem('configData'));

	if (configData.firstName && configData.firstName != '') {
		$('.pl-steplabel').text(configData.firstName + "'s Trailer Configuration is Complete!");
		$('.btn-brochure').text("View " + configData.firstName + "'s Custom Airstream");
	}

	configData.configStep = 'summary';
	sessionStorage.setItem('configData', JSON.stringify(configData));
	localStorage.setItem('configData', JSON.stringify(configData));

	for (i = 0; i < urlVariables.length; i++) {
		var varName = urlVariables[i].split('=');
		if (varName[0] == 'options') {
			storedOptions = varName[1].split(',');
		}
	}

	$('#dealZip').keyup(function (e) {
		if ($(this).val().length >= 5) {
			doDealerSearch($.sanitize($(this).val()));
		}
	});

	//remove options from variables to rebuild with potentially removed IDs
	urlVariables.pop();

	$('.pl-remove-selected-option').click(function (e) {
		e.preventDefault();
		var optionToRemove = $(this).attr('option-id');

		var arrIndex = $.inArray(optionToRemove, storedOptions);

		if (arrIndex !== -1) {
			storedOptions.splice(arrIndex, 1);
		}

		var localOptions = configData.options.split(',');
		localOptions.splice($.inArray(optionToRemove, localOptions), 1);

		$(this).parent().parent('.pl-row').remove();
		$('#option-' + optionToRemove + '-image').remove();

		var removedOptionPrice = Number($(this).siblings('.pl-row-price').text().replace(/[^0-9.-]+/g, ""));
		var currentOptionsTotal = Number($('#options-price').text().replace(/[^0-9.-]+/g, ""));
		var currentMSRP = Number($('#msrp').text().replace(/[^0-9.-]+/g, ""));

		$('#options-price').text("$" + (currentOptionsTotal - removedOptionPrice).toLocaleString(undefined, { minimumFractionDigits: 0 }));
		$("#msrp").text("$" + (currentMSRP - removedOptionPrice).toLocaleString(undefined, { minimumFractionDigits: 0 }));

		configData.options = localOptions.join();
		sessionStorage.setItem('configData', JSON.stringify(configData));
	});

	jQuery('.btn-request-quote').click(function (e) {
		e.preventDefault();
		jQuery('.quote-modal').show();
		jQuery('.quote-modal').addClass('active');
		setHubspotFields();
	});

	jQuery('.btn-brochure').click(function (e) {
		e.preventDefault();
		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));
		window.location.href = '/configurator/tt/brochure/' + buildURLParams();
	});

	jQuery('.pl-modal').on('click', '.pl-modal-close span', function (e) {
		jQuery('.active').hide();
		jQuery('.active').removeClass('active');
	});

	jQuery('#brochureForm').submit(function (e) {
		e.preventDefault();
		var first = $.sanitize($('#first').val()),
		    last = $.sanitize($('#last').val()),
		    email = $.sanitize($('#email').val()),
		    zip = $.sanitize($('#zip').val());

		//configData.userData = {};

		configData.customer = first + "-" + last;
		configData.email = email;
		configData.zip = zip;

		//console.log(configData);

		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));

		window.location.href = '/configurator/tt/brochure/' + buildURLParams();
	});

	$('#dealerForm').submit(function (e) {
		e.preventDefault();
		var first = $.sanitize($('#dealFirst').val()),
		    last = $.sanitize($('#dealLast').val()),
		    email = $.sanitize($('#dealEmail').val()),
		    zip = $.sanitize($('#dealZip').val()),
		    phone = $.sanitize($('#dealPhone').val()),
		    message = $.sanitize($('#dealMessage').val()),
		    contactMethod = $.sanitize($('input.dealContactMethod:checked').val()),
		    dealerId = $.sanitize($('input#dealerId').val()),
		    dealerAirId = $.sanitize($('input#dealerAirId').val());

		configData.quoteData = {};

		configData.quoteData.name = first + '-' + last;
		configData.quoteData.email = email;
		configData.quoteData.zip = zip;
		configData.quoteData.phone = phone;
		configData.quoteData.message = message;
		configData.quoteData.contactMethod = contactMethod;
		configData.quoteData.dealerId = dealerId;
		configData.quoteData.dealerAirstreamId = dealerAirId;

		//console.log(configData);

		sessionStorage.setItem('configData', JSON.stringify(configData));
		localStorage.setItem('configData', JSON.stringify(configData));

		var dealerQuoteData = {
			'name': first + ' ' + last,
			'email': email,
			'zip': zip,
			'phone': phone,
			'message': message,
			'contactMethod': contactMethod
		};
	});

	jQuery('.nav-link').click(function (e) {
		if (jQuery(this).hasClass('showExterior')) {
			jQuery('#exteriorShot').show();
			jQuery('#interiorShot').hide();
		} else {
			jQuery('#interiorShot').show();
			jQuery('#exteriorShot').hide();
		}
	});
});
function setHubspotFields() {
	getSession().then(function (data) {
		if (typeof hbspt !== "undefined") {
			document.querySelectorAll("input[name=interested_product_model]")[0].value = data;
		}
	});
	var currentPath = window.location.href;
	document.querySelectorAll("input[name=tt_configurator_brochure_link]")[0].value = currentPath;
}

},{}]},{},[1]);
